enum NodeDocumentPositionEnum {
	disconnect = 0x01,
	preceding = 0x02,
	following = 0x04,
	contains = 0x08,
	containedBy = 0x10,
	implementationSpecific = 0x20
}

export default NodeDocumentPositionEnum;
